import { ServiceType } from "@agroyaar/sdk";
import { LeadingExpert } from "../../../../../../features/my-colleagues/domain/my-colleagues.interface";
import { joinBaseURLWithPath } from "../../../../../utils/joinBaseURLWithPath";
import { useImgBase64 } from "../../../hooks/useImgBase64";

import { reportColor } from "../../../utils/report-color";

interface ExpertInformationProps {
  leadingExpert: LeadingExpert;
  serviceType: ServiceType;
}

const ExpertInformation = ({
  leadingExpert,
  serviceType,
}: ExpertInformationProps) => {
  const colorCode = reportColor(serviceType!);

  const [img] = useImgBase64(joinBaseURLWithPath(leadingExpert.avatar));

  return (
    <div className="flex flex-col justify-center items-start w-1/2 gap-2">
      <span className="font-bold text-[20px] text-[#222]">اطلاعات کارشناس</span>

      <div className="flex flex-row justify-end items-center gap-[19px] w-full">
        <img
          src={img}
          alt={leadingExpert.fullName}
          width={70}
          height={70}
          className="rounded-full"
          style={{ border: `2px solid ${colorCode}` }}
        />
        <div className="flex flex-col justify-center items-start gap-[6px] font-bold text-[18px] text-[var(--agrotext)]">
          <span className="font-bold text-[18px] !font-[B-Nazanin]">
            {leadingExpert.fullName}
          </span>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              کد کارشناسی:
            </span>
            <span className="font-bold text-[16px] !font-[B-Nazanin]">
              {leadingExpert.expertCode}
            </span>
          </div>

          <div className="flex flex-row items-start gap-[8px]">
            <span className="font-bold text-[18px] !font-[B-Nazanin]">
              استان و شهر:
            </span>
            <span className="font-bold text-[16px] !font-[B-Nazanin]">
              {leadingExpert.province.name}، {leadingExpert.city.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertInformation;
